(ns web3.screens.drawer
  (:require [web3.i18n :as i]
            [web3.view :as v]
            [web3.components.icons :as icons]
            [web3.components.widgets :as widgets]
            [web3.components.intercom :as intercom]
            [web3.persistence.schema :as schema]
            [web3.routers.policy-redirect] ;; for fx - moved to routers b/c I want this to be a route soon
            [web3.routing.core :as routing]
            [web3.screens.sponsor :as sponsor]
            [web3.env :as env]
            [web3.utils :as utils]
            [web3.screens.pro.offer :as pro]
            [web3.screens.pro.utils :as pro-utils]
            [web3.tracking.components :as tc]
            [web3.persistence.current-property :as current-property]
            [web3.routers.app-helpers :as app-route]
            [web3.icons.shapes :as shapes]
            [web3.view.hiccup :as hiccup]
            [web3.queries.root :as q-root])
  (:require-macros [web3.build.versions :as versions]))

(def separator [:div.margin-all-3 {:style {:border-bottom "thin solid rgb(226, 226, 226)"}}])
(def upper-separator [:div.margin-h-3.margin-bottom-2.margin-top-3 {:style {:border-bottom "thin solid rgb(226, 226, 226)"}}])
(def drawer-link-classes "  flex-auto text-black pad-h-3 pad-v-2 cursor-pointer hover-text-black-hover")
(def drawer-header-height 132)

(defn drawer-header-sponsor [props sponsor]
  [:a.centriq-gradient.pad-left-3.pad-v-4.cursor-pointer.block.flex-none
   (v/merge-props
    {:class "text-black"
     :style {:margin-top "-16px"}}
    props)
   [:div.flex.items-stretch.flex-auto.hover-opacity-parent
    [sponsor/with-address sponsor]
    [:div.flex-auto]
    [widgets/chevron-action {}]]])

(defn- drawer-link*
  [{:keys [label-key href chevron?] :as props} children]
  (let [props (dissoc props :chevron?)]
   [:div.flex.mdc-ripple-surface.pad-right-2
    [(if href tc/a :div)
     (-> props
         (dissoc :label-key)
         (update :class str " " drawer-link-classes)
         (assoc :key label-key))
     (i/get label-key)
     children]
    [:div.text-dark-gray.inline-block.pad-h-2.margin-v-auto
     (when chevron? shapes/chevron-right)]]))

(defn drawer-link [props & children]
  (drawer-link* props children))

(defn drawer-link-chevron [props & children]
  (drawer-link* (merge props {:chevron? true})
                children))

(def page-index
  {"terms" "https://www.homeserve.com/en-us/app/terms"
   "privacy" "https://www.homeserve.com/sc/legal/privacy-policy"
   "quick-start" "https://www.homeserve.com/en-us/app/how-it-works/"
   "faq" "https://www.homeserve.com/en-us/app/help/"})

(v/defview drawer-home
  "Content for global navigation drawer."
  {:header {:title (i/get :i/account)}}
  []
  (let [current-property (current-property/get-property)
        pro? (pro-utils/pro?)]
    [:div.text-label.flex.flex-column.flex-auto.height-100p
     [:div.bg-white
      (when-let [sponsor (first (:sponsors current-property))]
        [drawer-header-sponsor
         {:href (routing/path-for [:account/sponsor])}
         sponsor])
      [:div.bg-off-white
       [:div.pad-top-4.pad-h-3.text-category.text-size-10 (i/to-do "Current Property")]
       (let [[line-1 line-2 line-3] (schema/property-display-lines current-property)]
         [:div.flex.items-center.pad-top-3.text-black.flex-none
          (if current-property (cond-> [:div.pad-h-3.flex-auto.weight-regular
                                        [:div.text-size-15.weight-semi-bold.text-uppercase.line-h-19 line-1]]
                                 (utils/some-str line-2) (conj line-2)
                                 (utils/some-str line-3) (into [[:br] line-3]))
                               [:div.pad-h-3.margin-v-4.flex-auto (i/get :i/my-properties)])])
       upper-separator
       [drawer-link-chevron {:label-key :i/other-properties
                             :href (routing/path-for {:router/drawer [:properties/index]})}]
       [:div.pad-bottom-2]]

      ;; spacer, to keep drawer home at max width
      [:div.pad-top-3
       {:style {:width 1000}}]

      (for [{:keys [label-key] :as props}
            [{:href (routing/path-for {:router/root [:home]})
              :label-key :nav-link/home}
             (when (current-property/get-property)
               {:href (routing/path-for {:router/root [:files :property-id (current-property/get-id)]})
                :label-key :i/files})
             {:label-key :i/service-providers
              :href (routing/path-for [:service-providers/index])}]
            :when label-key]
        [drawer-link (assoc props :key label-key)])
      separator



      (for [{:keys [label-key] :as props}
            [{:label-key :i/help
              :chevron? true
              :href (routing/path-for [:account/support])}
             {:label-key :drawer/homeserve-policy
              :on-click #(re-frame.core/dispatch [:do/redirect.policy])} ;; TODO - figure out if there's a routeful approach
             {:label-key :i/contact-us
              :on-click intercom/show!}
             {:label-key :i/account
              :chevron? true
              :href (routing/path-for [:account/profile])}]]
        (when (not-empty props)
         [drawer-link (assoc props :key label-key)]))

      [drawer-link {:label-key :i/export
                    :on-click #(intercom/show! (i/get :drawer/export-intercom
                                                      {:partnerName (:partner/name env/config)
                                                       :email (get-in (q-root/me) [:me :email])
                                                       :uuid (get-in (q-root/me) [:me :id])}))}]


      (when pro?
        [drawer-link-chevron
         {:style {:color "black"}
          :href (routing/path-for [:pro/start])
          :label-key :i/professional-profile}
         (-> pro-utils/icon-flag
             (assoc-in [1 :height] 14))])

      [drawer-link {:label-key :i/logout
                    :href (routing/path-for {:router/root [:logout]})}]
      separator
      [drawer-link-chevron {:key :tell
                            :label-key :i/share-centriq
                            :href (routing/path-for [:marketing/tell-a-friend])}]
      [drawer-link-chevron {:key :social
                            :label-key :i/social
                            :href (routing/path-for [:marketing/social])}]
      separator
      [drawer-link {:key :privacy
                    :label-key :i/privacy
                    :target "_blank"
                    :rel "noopener"
                    :href (page-index "privacy")}]
      [drawer-link {:key :link.terms
                    :label-key :drawer/link.terms
                    :target "_blank"
                    :rel "noopener"
                    :href (page-index "terms")}]

      [:div.pad-bottom-3]]
     (when (and (:feature/pro? env/config)
                (not pro?))
       [:div.pad-h-3.pad-v-4 [pro/upgrade-offer]])
     [:div.flex-auto]


     [:div.pad-h-3.text-dark-gray.text-uppercase.text-size-11.flex.flex-wrap.flex-row-reverse

      [:div.text-gray.text-size-11.pad-v-3.pad-right-3.flex-auto.text-right (versions/version-string)]

      [tc/a
       {:class "flex flex-auto text-center pad-right-3 items-center text-dark-gray visited-dark-gray hover-text-blue"
        :href "https://myhome.homeserve.com/"
        :target "_blank"
        :rel "noopener"
        :style {:max-width "175px"}}
       [:div.weight-semi-bold(i/to-do "Powered by HomeServe")]]]]))



(defn drawer-page-link [{:keys [label href icon] :as props}]
  [(if href :a :div)
   (-> props
       (dissoc :label)
       (update :class str " cursor-pointer pad-all-3 flex items-center text-black hover-text-real-black hover-opacity-parent ")
       (assoc :key label))
   [:div.flex-auto (i/get label)]
   (-> (or icon shapes/chevron-right)
       (hiccup/class "hover-opacity-child")
       (hiccup/size 12))])


(v/defview support
  {:header {:title "Support"}}
  []
  [:div
   (interleave (doall (map drawer-page-link
                           [
                            {:label :drawer/link.quick-start
                             :target "_blank"
                             :rel "noopener"
                             :href (page-index "quick-start")}
                            {:label :drawer/link.nameplate-help
                             :target "_blank"
                             :rel "noopener"
                             :href (app-route/nameplate-locator-href)}
                            {:label :drawer/link.faq
                             :target "_blank"
                             :rel "noopener"
                             :href (page-index "faq")}
                            {:label :drawer/link.contact
                             :icon shapes/blank
                             :href (routing/path-for [:intercom/show])}]))


               (map (fn [i]
                      [:div.margin-h-3.hover-text-underline
                       {:key i
                        :style {:border-bottom "thin solid #e2e2e2"}}]) (range)))])


(defn drawer-social-link [{:keys [label href icon] :as props}]
  [(if href tc/a :div)
   (-> props
       (dissoc :label :icon)
       (update :class str " cursor-pointer pad-all-3 flex items-center text-black hover-text-real-black hover-opacity-parent ")
       (assoc :key label
              :target "_blank"
              :rel "noopener noreferrer"))
   (when icon
     (-> icon
         (hiccup/size 28)
         (hiccup/class "pad-right-2")
         (hiccup/styles {:color "black"})))

   [:div.flex-auto label]
   shapes/chevron-right])


(v/defview social
  {:header {:title "Support"}}
  []
  [:div
   (interleave (doall (map drawer-social-link
                           (let [partner-name "Homeserve USA"
                                 label-fn (fn [i-k] (i/get i-k {:partnerName partner-name}))]
                            [{:label (label-fn :i/facebook)
                              :icon (icons/get "facebook")
                              :href "https://www.facebook.com/HomeServeUSA/"}
                             {:label (label-fn :i/instagram)
                              :icon (icons/get "instagram")
                              :href "https://www.instagram.com/teamhomeserveusa/"}
                             {:label (label-fn :i/twitter)
                              :icon (icons/get "twitter")
                              :href "https://twitter.com/HomeServeUSA"}
                             {:label (label-fn :i/linkedin)
                              :icon (icons/get "linkedin")
                              :href "https://www.linkedin.com/company/homeserve-usa/"}])))


               (map (fn [i]
                      [:div.margin-h-3.hover-text-underline
                       {:key i
                        :style {:border-bottom "thin solid #e2e2e2"}}]) (range)))])


(comment

 ;; little test of fetching content from Centriq website.
 ;; (does not work b/c of cross-origin issue)

 (v/defview support-page [{:keys [page-id]}]
   [widgets/html-fetch {:url (get page-index page-id)
                        :selector "mn-content"}]))
